import React from 'react';
import { Image, T } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import IconCheckMark from '@static/images/icon_check.svg';
import IconXMark from '@static/images/icon_x.svg';
import { ProfileUsername } from '../ProfileUsername/ProfileUsername.tsx';
import styles from './GameDetailsPlayersTable.module.scss';
export const GameDetailsPlayersTable = ({ game, onUsernameClick })=>{
    const playersByRank = [
        ...game.players
    ].sort((first, second)=>first.rank - second.rank);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("table", {
        className: styles.table
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("th", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:leaderboardPage.tableHeaders.player'
        }
    })), /*#__PURE__*/ React.createElement("th", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.history.table.rank.title'
        }
    })), /*#__PURE__*/ React.createElement("th", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.history.table.vp.title'
        }
    })), /*#__PURE__*/ React.createElement("th", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.history.table.finished.title'
        }
    })), /*#__PURE__*/ React.createElement("th", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.history.table.karmaPenalty.title'
        }
    })))), /*#__PURE__*/ React.createElement("tbody", null, playersByRank.map((player)=>/*#__PURE__*/ React.createElement("tr", {
            key: player.rank
        }, /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(ProfileUsername, {
            username: player.username,
            hasProfile: player.hasProfile,
            onUsernameClick: onUsernameClick
        })), /*#__PURE__*/ React.createElement("td", null, `${player.rank}/${game.players.length}`), /*#__PURE__*/ React.createElement("td", null, `${player.points}/${game.victoryPointsToWin}`), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(Image, {
            image: {
                src: player.finished ? IconCheckMark : IconXMark,
                alt: emptyTranslation
            }
        })), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(Image, {
            image: {
                src: player.quitWithPenalty ? IconCheckMark : IconXMark,
                alt: emptyTranslation
            }
        })))))));
};
